<template>
	<div class="adsearchs">
		<el-form v-model="searchParams" @submit.native.prevent>
			<div class="adsearchkey" :class="searchParams.searchValue ? 'active-search' : ''">
				<div class="inputsearch">
					<!-- <el-input v-model="searchParams.searchValue" clearable @clear="handleSearch" class="input-with-select" placeholder="海量资源 等你发现" @keyup.enter.native="handleSearch">
						<el-select slot="prepend" v-model="searchParams.itype" placeholder="全部">
							<el-option v-for="item in catOpt" :key="item.id" :label="item.name" :value="item.id"> </el-option>
						</el-select>
					</el-input> -->

					<el-tabs v-model="searchParams.itype" type="card" @tab-click="handleTabClick">
						<el-tab-pane v-for="item in catOpt" :key="item.id" :name="String(item.id)" :label="item.name"></el-tab-pane>
					</el-tabs>

					<el-autocomplete
						v-if="searchParams.itype == 0"
						class="inline-input input-with-select"
						v-model="searchParams.searchValue"
						:fetch-suggestions="querySearch"
						placeholder="海量资源 等你发现"
						clearable
						@clear="handleSearch"
						:trigger-on-focus="false"
						@keyup.enter.native="handleSearch"
						@select="handleSearchSelect"
						popper-class="standard-autocomplete-popper"
						highlight-first-item
						style="flex: 1"
					>
						<template slot-scope="{ item }">
							<div class="suggestion-item">
								<span class="suggestion-item-code" v-if="item.standardCode">{{ item.standardCode }}</span>
								<span class="suggestion-item-name">{{ item.standardName }}</span>
							</div>
						</template>
					</el-autocomplete>
					<el-input
						class="inline-input input-with-select"
						style="flex: 1"
						v-if="searchParams.itype == 1"
						v-model="searchParams.searchValue"
						clearable
						@clear="handleSearch"
						placeholder="海量资源 等你发现"
						@keyup.enter.native="handleSearch"
					></el-input>
					<!-- <input v-model.trim="searchParams.searchValue" clearable @clear="handleSearch" @keyup.enter="handleSearch" class="keyinput" placeholder="输入标准编号、名称或关键词..." type="text" /> -->
				</div>
				<div class="search-btns">
					<el-button icon="el-icon-search" round type="primary" @click="handleSearch"> 检索</el-button>
					<el-button icon="el-icon-refresh-right" round @click="handleReset">重置</el-button>
				</div>
			</div>

			<div class="more-search">
				<div class="more-search-row">
					<div class="more-search-left">
						<el-checkbox v-model="showProduct" @change="handleShowProduct">显示商品信息</el-checkbox>
						<el-checkbox v-model="queryType" @change="handleQueryType">加载全国标准库（30万+）</el-checkbox>
					</div>
					<div class="more-search-toggle" @click="showMore = !showMore">
						<i :class="showMore ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
						<span>{{ showMore ? '收起更多查询' : '更多查询条件' }}</span>
						<span v-if="hasMoreFilter" class="more-filter-dot"></span>
					</div>
				</div>

				<transition name="panel-slide-down">
					<div class="more-search-panel" v-show="showMore">
						<el-row :gutter="16">
							<el-col :span="12">
								<el-form-item label="标准名称：">
									<el-input v-model="searchParams.standardName" placeholder="请输入标准名称" size="small" clearable></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="标准号：">
									<el-input v-model="searchParams.standardCode" placeholder="请输入标准号" size="small" clearable></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="16">
							<el-col :span="12">
								<el-form-item label="国际标准分类号：">
									<el-input v-model="searchParams.icsIdentify" placeholder="ICS" size="small" clearable></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="中国标准分类号：">
									<el-input v-model="searchParams.ccsIdentify" placeholder="CCS" size="small" clearable></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="16">
							<el-col :span="12">
								<el-form-item label="被代替国标号：">
									<el-input v-model="searchParams.replaceCode" placeholder="请输入" size="small" clearable></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="主管部门：">
									<el-input v-model="searchParams.headAgency" placeholder="请输入" size="small" clearable></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="16">
							<el-col :span="12">
								<el-form-item label="归口单位：">
									<el-input v-model="searchParams.underAgency" placeholder="请输入" size="small" clearable></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="起草单位：">
									<el-input v-model="searchParams.draftInfo" placeholder="请输入" size="small" clearable></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="16">
							<el-col :span="12">
								<el-form-item label="发布日期：">
									<el-date-picker
										v-model="releaseDate"
										type="daterange"
										range-separator="至"
										start-placeholder="开始"
										end-placeholder="结束"
										value-format="yyyy-MM-dd"
										size="small"
										style="width: 100%"
									></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="实施日期：">
									<el-date-picker
										v-model="executeDate"
										type="daterange"
										range-separator="至"
										start-placeholder="开始"
										end-placeholder="结束"
										value-format="yyyy-MM-dd"
										size="small"
										style="width: 100%"
									></el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
						<div class="more-search-footer">
							<el-button @click="handleMoreReset">清空</el-button>
							<el-button type="primary" @click="handleMoreSearch">查询</el-button>
						</div>
					</div>
				</transition>
			</div>
		</el-form>
	</div>
</template>

<script>
	import { getLifeStandardLabel, getMajorStandardLabel, getStandardCategory, getSearchList } from '@/api/standards/search';
	import moment from 'moment';
	import merge from 'webpack-merge';
	import { mapActions, mapGetters } from 'vuex';

	export default {
		inject: ['updateAdgrandData', 'clearLeftSearchBox'], // 注入祖父组件提供的方法
		data() {
			return {
				checkAll: false,
				showMore: false,
				showProduct: false,
				queryType: false,

				releaseDate: null,
				executeDate: null,

				catOpt: [
					{
						id: 0,
						name: '文件编号/标题'
					},
					{
						id: 1,
						name: '全文检索'
					}
				],

				searchParams: {
					searchValue: '',
					issueAgency: '',
					underAgency: '',
					issueBegin: '',
					issueEnd: '',
					effectiveBegin: '',
					effectiveEnd: '',
					itype: '0',
					standardName: '',
					standardCode: '',
					icsIdentify: '',
					ccsIdentify: '',
					replaceCode: '',
					headAgency: '',
					draftInfo: '',
					standardDomain: ''
				}
			};
		},
		computed: {
			hasMoreFilter() {
				const p = this.searchParams;
				return !!(p.standardName || p.standardCode || p.icsIdentify || p.ccsIdentify || p.replaceCode || p.headAgency || p.draftInfo || this.releaseDate || this.executeDate);
			}
		},
		created() {
			this.$nextTick(() => {
				if (this.$route.query.keyword) {
					this.searchParams.searchValue = this.$route.query.keyword || '';
					this.handleSearch();
				}
			});
		},
		methods: {
			...mapActions('Settings', ['setLoginShow']),
			// 是否显示商品信息
			handleShowProduct(val) {
				this.$emit('showProduct', val);
			},

			// 是否显示全国标准库
			handleQueryType(val) {
				this.queryType = false;
				this.setLoginShow(true);
				// this.$emit('queryType', val ? 0 : 1);
			},

			handleTabClick(tab) {
				this.searchParams.itype = tab.name;
			},

			handleSelect(id) {
				this.searchParams.itype = id;
			},

			resetSearchParams() {
				this.searchParams.standardName = '';
				this.searchParams.standardCode = '';
				this.searchParams.icsIdentify = '';
				this.searchParams.ccsIdentify = '';
				this.searchParams.replaceCode = '';
				this.searchParams.headAgency = '';
				this.searchParams.draftInfo = '';
				this.searchParams.standardDomain = '';
				this.searchParams.issueAgency = '';
				this.searchParams.underAgency = '';
				this.searchParams.issueBegin = '';
				this.searchParams.issueEnd = '';
				this.searchParams.effectiveBegin = '';
				this.searchParams.effectiveEnd = '';
				this.searchParams.searchValue = '';
				this.releaseDate = null;
				this.executeDate = null;
				this.searchParams.itype = '0';
				this.showProduct = false;
				this.queryType = false;
				this.$emit('showProduct', false);
				this.$emit('queryType', 1);
				this.$store.dispatch('Settings/setResetStandardsList', false);
				// this.updateAdgrandData(this.searchParams);
			},

			async querySearch(queryString, cb) {
				let res = await getSearchList({
					searchValue: queryString.trim()
					// industryId: [1]
				});
				let results = [];
				if (res.code == 200) {
					results = res.data.map(item => {
						const { standardName, standardCode } = item;
						//判断，如果standardCode为空，则不显示 如果有standardCode，则显示standardCode
						const label = `${standardCode ? `${standardCode}` : ''} ${standardName}`;
						return { value: label, standardCode, standardName };
					});
					cb(results);
				}
			},

			handleReset() {
				// 清除 URL 上的搜索关键词
				this.$router.replace({
					query: merge(this.$route.query, { keyword: '' })
				});

				// 原地重置所有查询参数（保持同一对象引用，确保 el-tabs v-model 响应式生效）
				this.searchParams.searchValue = '';
				this.searchParams.standardName = '';
				this.searchParams.standardCode = '';
				this.searchParams.icsIdentify = '';
				this.searchParams.ccsIdentify = '';
				this.searchParams.replaceCode = '';
				this.searchParams.headAgency = '';
				this.searchParams.draftInfo = '';
				this.searchParams.standardDomain = '';
				this.searchParams.issueAgency = '';
				this.searchParams.underAgency = '';
				this.searchParams.issueBegin = '';
				this.searchParams.issueEnd = '';
				this.searchParams.effectiveBegin = '';
				this.searchParams.effectiveEnd = '';
				this.releaseDate = null;
				this.executeDate = null;
				this.searchParams.itype = '0';
				this.showProduct = false;
				this.showProduct = false;
				this.queryType = false;
				this.$emit('showProduct', false);
				this.$emit('queryType', 1);

				// 移除左边所有查询条件
				this.clearLeftSearchBox();

				this.$store.dispatch('Settings/setResetStandardsList', true);
				this.updateAdgrandData(this.searchParams);
			},

			handleMoreReset() {
				// 清除 URL 上的搜索关键词
				this.$router.replace({
					query: merge(this.$route.query, { keyword: '' })
				});
				// 原地重置所有查询参数（保持同一对象引用，确保 el-tabs v-model 响应式生效）
				this.searchParams.standardName = '';
				this.searchParams.standardCode = '';
				this.searchParams.icsIdentify = '';
				this.searchParams.ccsIdentify = '';
				this.searchParams.replaceCode = '';
				this.searchParams.headAgency = '';
				this.searchParams.draftInfo = '';
				this.searchParams.standardDomain = '';
				this.searchParams.issueAgency = '';
				this.searchParams.underAgency = '';
				this.releaseDate = null;
				this.executeDate = null;
				this.searchParams.itype = '0';

				// 重置选择器
				this.releaseDate = null;
				this.executeDate = null;

				this.$store.dispatch('Settings/setResetStandardsList', true);
				this.showMore = false;
				this.showProduct = false;
				this.queryType = false;
				this.$emit('showProduct', false);
				this.$emit('queryType', 1);
			},

			handleMoreSearch() {
				this.handleSearch();
				this.showMore = false;
			},

			handleSearchSelect(e) {
				console.log('handleSearchSelect', e);
				//移除左边所有查询条件
				this.clearLeftSearchBox();
				this.searchParams.searchValue = e.value;
				this.handleSearch();
			},

			handleSearch() {
				if (this.releaseDate == null) {
					this.searchParams.issueBegin = '';
					this.searchParams.issueEnd = '';
				} else {
					if (this.releaseDate[0]) {
						this.searchParams.issueBegin = moment(this.releaseDate[0]).format('YYYY-MM-DD');
					}
					if (this.releaseDate[1]) {
						this.searchParams.issueEnd = moment(this.releaseDate[1]).format('YYYY-MM-DD');
					}
				}
				if (this.executeDate == null) {
					this.searchParams.effectiveBegin = '';
					this.searchParams.effectiveEnd = '';
				} else {
					if (this.executeDate[0]) {
						this.searchParams.effectiveBegin = moment(this.executeDate[0]).format('YYYY-MM-DD');
					}
					if (this.executeDate[1]) {
						this.searchParams.effectiveEnd = moment(this.executeDate[1]).format('YYYY-MM-DD');
					}
				}

				this.searchParams.searchValue = this.searchParams.searchValue.trim();
				let params = { ...this.searchParams };

				// return
				this.updateAdgrandData(params);
				return;

				// 将多个参数封装为对象
				// const params = {
				// 	// searchValue: this.searchValue,
				// 	issueAgency: this.adsearchform.issueAgency,
				// 	releaseDate: this.adsearchform.releaseDate,
				// 	underAgency: this.adsearchform.underAgency,
				// 	executeDate: this.adsearchform.executeDate
				// };
			}
		}
	};
</script>

<style lang="less" scoped>
	@border: 1px solid #cee2f9;
	@boxshadow: 0px 0px 5px 0px rgba(20, 116, 226, 0.5);
	.adsearchs {
		border-radius: 16px;
		background-color: transparent;
		margin-bottom: 20px;

		// 搜索卡片 - 突出检索框 参考 lz_project store
		.adsearchkey {
			background-color: #ffffff;
			display: flex;
			align-items: center;
			padding: 10px 14px;
			border-radius: 16px;
			border: 1px solid #e2e8f0;
			box-shadow: 0 4px 20px rgba(37, 99, 235, 0.06), 0 2px 6px rgba(0, 0, 0, 0.03);
			box-shadow: 0 8px 30px rgba(37, 99, 235, 0.15), 0 4px 12px rgba(0, 0, 0, 0.06);
			gap: 12px;
			transition: all 0.25s ease;

			&:hover {
				// box-shadow: 0 8px 28px rgba(37, 99, 235, 0.1), 0 4px 10px rgba(0, 0, 0, 0.05);
				// border-color: #cbd5e1;
			}

			&:focus-within {
				box-shadow: 0 8px 30px rgba(37, 99, 235, 0.15), 0 4px 12px rgba(0, 0, 0, 0.06);
				border-color: #2563eb;
			}

			.inputsearch {
				flex: 1;
				height: auto;
				display: flex;
				align-items: center;
				gap: 8px;
				min-height: 52px;

				.keyinput {
					border: 0;
					height: 47px;
					line-height: 47px;
					width: 100%;
				}

				.search-type {
					background: #fff;
					border: 1px solid #f1f5f9;
					color: #606266;
					text-align: center;
					box-sizing: border-box;
					transition: 0.1s;
					font-weight: 500;
					font-size: 14px;
					border-radius: 4px;
					padding: 9px 12px;
					margin-left: 10px;
				}

				.search-type-active {
					color: #2563eb;
					background: #eff6ff;
					border: 1px solid #2563eb;
				}
			}

			.search-btns {
				display: flex;
				align-items: center;
				gap: 12px;
				flex-shrink: 0;
			}

			// 检索按钮突出
			/deep/ .el-button--primary {
				padding: 12px 28px;
				font-size: 15px;
				font-weight: 600;
				height: 46px;
				box-shadow: 0 4px 14px rgba(37, 99, 235, 0.25);
				transition: all 0.25s ease;

				&:hover {
					transform: translateY(-1px);
					box-shadow: 0 6px 20px rgba(37, 99, 235, 0.35);
				}
			}

			/deep/ .el-button:not(.el-button--primary) {
				height: 46px;
				padding: 12px 20px;
				font-size: 14px;
			}
		}

		.active-search {
			box-shadow: 0 8px 30px rgba(37, 99, 235, 0.15), 0 4px 12px rgba(0, 0, 0, 0.06);
			border-color: #2563eb;
		}
		.adsearchcon {
			padding: 20px;
			.form-group {
				//width: 268px;
				//margin: 10px 48px 0 20px;
			}
			/* 标题样式（label 本身是行内元素，设置为块级元素会自动换行） */
			.form-label {
				display: block; /* 关键：让标题成为块级元素，独占一行 */
				margin-bottom: 10px; /* 标题与输入框之间的间距 */
				font-weight: 400; /* 标题加粗 */
				color: #333;
			}
			/* 输入框样式（input 默认是行内块，设置 width: 100% 占满一行） */
			.form-input {
				width: 100%; /* 输入框占满容器宽度 */
				// padding: 8px 12px;
				height: 38px;
				border: @border;
				// box-shadow: @boxshadow;
				border-radius: 5px;
				box-sizing: border-box; /* 确保 padding 不影响总宽度 */
			}
			.inputsearch /deep/ .el-input__inner {
				border: @border;
				// box-shadow: @boxshadow;
				border-radius: 5px;
			}
			.topicgroup {
				padding-top: 10px;
				// padding-bottom: 20px;
				display: flex;
				.title {
					margin-bottom: 4px;
					margin-top: 6px;
					font-size: 14px;
					color: #333;
					float: left;
					margin-right: 10px;
					min-width: 56px;
					flex-shrink: 0;
				}
				/deep/ .el-checkbox__inner {
					border: @border;
					// box-shadow: @boxshadow;
				}
			}
		}
		/deep/.el-input-group__prepend .el-select {
			width: 140px;
			// color: #1474e2;
			color: #333;
			transition: all 0.3s ease;
			box-shadow: 16px 0px 40px 0px rgba(0, 122, 255, 0.1);
			// border-radius: 4px;
			// border: 1px solid #f1f5f9;
		}
		/deep/.el-input-group__prepend .el-select:hover {
			// color: #0f5bb8;
			// border-radius: 4px;
			// border: 1px solid #f1f5f9;
		}

		.inputsearch /deep/.el-input__inner {
			height: 40px;
			line-height: 40px;
			border: 0;
			border-radius: 10px;
			font-size: 15px;
			background: transparent;
			padding-left: 14px;
			transition: all 0.2s ease;
		}

		.inputsearch /deep/.el-input__inner::placeholder {
			color: #94a3b8;
			font-size: 14px;
		}

		// tabs 样式优化 - 更紧凑
		/deep/ .el-tabs {
			margin-top: 0 !important;
			margin-right: 8px;
			flex-shrink: 0;
		}

		/deep/ .el-tabs__header {
			margin: 0;
			border: 0;
		}

		/deep/ .el-tabs--card > .el-tabs__header {
			border-bottom: 0;
		}

		/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
			border: 1px solid #e2e8f0;
			border-radius: 8px;
			overflow: hidden;
		}

		.inputselect /deep/.el-input__inner {
			height: 36px;
			line-height: 36px;
		}

		.inputsearch /deep/.el-select .el-input .el-select__caret {
			color: #333;
		}

		.inputsearch /deep/.el-input-group__prepend div.el-select .el-input__inner,
		.inputsearch .el-input-group__prepend div.el-select:hover .el-input__inner {
			background-color: #ffffff;
			// border: 0;
			// border-radius: 4px;
			// font-weight: 500;
			// border: 1px solid #f1f5f9;
		}
		/deep/.el-input-group__prepend {
			// border: 0;
		}
		/deep/.el-input-group__prepend {
			color: #333333;
			font-weight: bold;
			border-left: 0;
			border-right: 1px solid #dcdfe6;
			position: relative;
		}
		/deep/.el-input-group__prepend p {
			position: absolute;
			top: 50%;
			transform: translate(0, -50%);
			font-size: 12px;
			font-weight: 400;
			color: rgb(192, 196, 204);
			margin-top: 16px;
			margin-left: -3px;
		}

		/deep/.input-with-select {
			border: 1px solid #e2e8f0;
			border-radius: 10px;
			min-width: 300px;
		}

		/deep/.input-with-select .el-input-group__prepend {
			background-color: #fff;
		}

		/* 动态选择器组件样式 */
		.select-group {
			flex: 1;
			// display: flex;
			flex-wrap: wrap;
			gap: 10px;
			// align-items: center;
			// margin-bottom: 15px;
		}

		.select-container {
			flex: 1;
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			position: relative;
			gap: 10px;
		}

		.select-item {
			// display: flex;
			// align-items: center;
			// gap: 8px;
			// flex: 1;
			// min-width: 200px;
		}

		.select-item {
			width: 76%;
			margin-bottom: 0;
			display: flex;
			align-items: center;
			flex: 0 0 auto;
		}

		.select-item .el-select {
			flex: 1;
		}

		.select-close {
			cursor: pointer;
			color: #909399;
			font-size: 14px;
			padding: 4px;
			border-radius: 50%;
			transition: all 0.3s ease;
			background-color: #f5f7fa;
			border: 1px solid #f1f5f9;
			margin-left: 6px;
		}

		.select-close:hover {
			color: #f56c6c;
			background-color: #fef0f0;
			border-color: #fbc4c4;
			transform: scale(1.1);
		}

		.select-controls {
			display: flex;
			align-items: center;
			gap: 8px;
		}

		.select-add {
			cursor: pointer;
			color: #409eff;
			font-size: 14px;
			padding: 4px;
			border-radius: 50%;
			transition: all 0.3s ease;
			background-color: #ecf5ff;
			border: 1px solid #b3d8ff;
		}

		.select-add:hover {
			color: #66b1ff;
			background-color: #d9ecff;
			border-color: #a0cfff;
			transform: scale(1.1);
		}

		.select-add:active {
			transform: scale(0.95);
		}

		/* 响应式布局 */
		@media screen and (max-width: 1300px) {
			.adsearchkey {
				flex-wrap: wrap;
				padding: 8px 12px;
				gap: 8px;
			}

			.inputsearch {
				flex-basis: 100%;
				min-height: 44px;
			}

			.search-btns {
				gap: 8px;
			}

			.search-btns /deep/ .el-button--primary {
				padding: 10px 20px !important;
				font-size: 14px !important;
				height: 40px !important;
				box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2) !important;

				&:hover {
					transform: none !important;
					box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3) !important;
				}
			}

			.search-btns /deep/ .el-button:not(.el-button--primary) {
				height: 40px !important;
				padding: 10px 16px !important;
				font-size: 13px !important;
			}
		}

		@media screen and (max-width: 768px) {
			.adsearchkey {
				padding: 6px 10px;
				gap: 6px;
			}

			.inputsearch {
				min-height: 40px;
				gap: 4px;
			}

			.search-btns {
				gap: 6px;
			}

			.search-btns /deep/ .el-button--primary {
				padding: 8px 16px !important;
				font-size: 13px !important;
				height: 36px !important;
				box-shadow: 0 1px 4px rgba(37, 99, 235, 0.18) !important;

				&:hover {
					transform: none !important;
					box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25) !important;
				}
			}

			.search-btns /deep/ .el-button:not(.el-button--primary) {
				height: 36px !important;
				padding: 8px 14px !important;
				font-size: 12px !important;
			}

			/deep/ .el-tabs__item {
				padding: 0 12px !important;
				font-size: 12px;
				height: 34px !important;
				line-height: 34px !important;
			}

			/deep/ .el-input__inner {
				font-size: 13px;
			}
		}

		@media (max-width: 768px) {
			.select-item {
				min-width: 100%;
			}
		}
	}

	/deep/ .el-tabs__item {
		height: 40px !important;
		line-height: 40px !important;
		font-size: 14px;
		border: 0 !important;
		padding: 0 18px !important;
		color: #64748b;
		transition: all 0.2s ease;
	}

	/deep/ .el-tabs__item.is-active {
		color: #ffffff;
		background: linear-gradient(135deg, #2563eb, #4f46e5);
		font-weight: 600;
	}

	/deep/ .el-tabs__item:hover:not(.is-active) {
		color: #2563eb;
		background: #f1f5f9;
	}

	.more-search {
		position: relative;

		.more-search-row {
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-wrap: wrap;
			gap: 8px;
			margin-top: 12px;
		}

		.more-search-left {
			display: flex;
			align-items: center;
			gap: 12px;
			flex-shrink: 0;

			/deep/ .el-checkbox {
				padding: 6px 16px;
				background: #f8fafc;
				border: 1px solid #e2e8f0;
				border-radius: 20px;
				transition: all 0.25s ease;
				margin-right: 0;

				&:hover {
					border-color: #bfdbfe;
					background: #eff6ff;
					box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
				}

				&.is-checked {
					background: #eff6ff;
					border-color: #93c5fd;
					box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);
				}
			}

			/deep/ .el-checkbox__label {
				font-size: 13px;
				font-weight: 600;
				color: #475569;
				transition: color 0.2s ease;
			}

			/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
				color: #2563eb;
			}
		}
	}

	.more-search-toggle {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		cursor: pointer;
		color: #2563eb;
		font-size: 13px;
		font-weight: 700;
		padding: 6px 16px;
		background: linear-gradient(135deg, rgba(37, 99, 235, 0.06), rgba(79, 70, 229, 0.06));
		border: 1px solid rgba(37, 99, 235, 0.2);
		border-radius: 20px;
		transition: all 0.25s ease;
		box-shadow: 0 1px 3px rgba(37, 99, 235, 0.06);
		flex-shrink: 0;

		&:hover {
			color: #1d4ed8;
			background: linear-gradient(135deg, rgba(37, 99, 235, 0.12), rgba(79, 70, 229, 0.12));
			border-color: rgba(37, 99, 235, 0.4);
			box-shadow: 0 2px 8px rgba(37, 99, 235, 0.15);
		}

		i {
			font-size: 13px;
			transition: transform 0.2s;
		}

		&:hover i {
			transform: translateY(1px);
		}

		.more-filter-dot {
			display: inline-block;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background: #f56c6c;
			flex-shrink: 0;
			box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.2);
		}
	}

	.more-search-panel {
		position: absolute;
		transform-origin: top center;
		top: 100%;
		left: 0;
		right: 0;
		z-index: 50;
		background: #fff;
		border: 1px solid #e2e8f0;
		border-radius: 12px;
		box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
		padding: 20px 20px 14px;
		margin-top: 4px;

		.more-search-close {
			position: absolute;
			top: 12px;
			right: 14px;
			cursor: pointer;
			font-size: 16px;
			color: #94a3b8;
			z-index: 1;
			padding: 4px;
			border-radius: 4px;
			transition: all 0.2s;

			&:hover {
				color: #475569;
				background: #f1f5f9;
			}
		}

		/deep/ .el-form-item {
			margin-bottom: 12px;
		}

		/deep/ .el-form-item__label {
			font-size: 12px;
			color: #64748b;
			font-weight: 500;
			line-height: 32px;
		}

		/deep/ .el-input__inner {
			height: 32px;
			line-height: 32px;
			border-color: #e2e8f0;
		}
	}

	.more-search-footer {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
		padding-top: 6px;
		border-top: 1px solid #f1f5f9;
		margin-top: 4px;
	}

	.panel-slide-down-enter-active {
		transition: max-height 0.35s ease-out, padding-top 0.35s ease-out, padding-bottom 0.35s ease-out;
		overflow: hidden;
	}
	.panel-slide-down-leave-active {
		transition: max-height 0.25s ease-in, padding-top 0.25s ease-in, padding-bottom 0.25s ease-in;
		overflow: hidden;
	}
	.panel-slide-down-enter,
	.panel-slide-down-leave-to {
		max-height: 0;
		padding-top: 0;
		padding-bottom: 0;
	}
</style>

<style lang="less">
.standard-autocomplete-popper {
	.el-autocomplete-suggestion__wrap {
		padding: 4px 0;
	}
	li {
		padding: 0 !important;
		line-height: normal !important;
		.el-autocomplete-suggestion__item {
			padding: 0;
		}
	}
	.suggestion-item {
		display: flex;
		align-items: center;
		padding: 8px 14px;
		cursor: pointer;
		gap: 8px;
	}
	.suggestion-item-code {
		font-size: 12px;
		color: #2563eb;
		font-weight: 600;
		white-space: nowrap;
		flex-shrink: 0;
		background: #eff6ff;
		padding: 2px 6px;
		border-radius: 4px;
	}
	.suggestion-item-name {
		font-size: 13px;
		color: #1e293b;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	li:hover {
		background: #f1f5f9;
	}
	li.highlighted {
		background: #edf3fe;
	}
}
</style>
